<template>
  <div class="score-page">
    <login-after-head-center></login-after-head-center>
    <div id="member" class="container home-container flex">
      <side-nav></side-nav>
      <div id="order-us" class="award-page">
        <div class="home-allTitle award-title-cg integral-orders-title fc-bet">
          <span>积分订单</span>
          <score-return-link></score-return-link>
        </div>
        <div class="award-nav award-nav-cg fc">
          <template v-for="(item, index) in statusTabs">
            <span
              :key="item.value"
              class="text hand"
              :class="{ 'goods-active': type === item.value }"
              @click="changeType(item.value)"
            >
              {{ item.label }}
            </span>
            <span
              v-if="index < statusTabs.length - 1"
              :key="`${item.value}-line`"
              class="line"
            ></span>
          </template>
        </div>
        <div v-loading="orderLoading" class="integral-orders">
          <div class="none-order" v-if="!orderLoading && orders.length === 0">
            <div class="none-left">
              <span class="none-left-img"></span>
            </div>
            <div class="none-right">
              <span>没有积分订单哦~</span>
            </div>
          </div>
          <article
            v-for="order in orders"
            :key="order.id"
            class="order-card"
            @click="viewDetail(order.id)"
          >
            <div class="order-header">
              <span>订单编号：{{ order.orderId || '--' }}</span>
              <strong>{{ getStatus(order) }}</strong>
            </div>
            <div class="order-time">提交时间：{{ order.createTime || '--' }}</div>
            <div v-for="(item, index) in order.cartInfo || []" :key="index" class="order-product">
              <img :src="productImage(item)" :alt="productName(item)">
              <div class="product-info">
                <strong>{{ productName(item) }}</strong>
                <span>{{ productSku(item) }}</span>
              </div>
              <div class="product-points">
                <span>{{ isSeckillItem(item) ? '秒杀' : '积分' }}{{ itemPointPrice(item) }}</span>
                <span>{{ item.cartNum || 0 }} 件</span>
              </div>
            </div>
            <div class="order-footer">
              <span>共{{ order.totalNum || totalNum(order) }}件</span>
              <span>总计：<strong>{{ order.payIntegral || totalPoints(order) }}积分</strong></span>
              <button
                v-if="canCancelOrder(order)"
                type="button"
                class="cancel-order-button"
                :disabled="Boolean(cancelingOrderId) || orderLoading"
                @click.stop="cancelOrder(order)"
              >
                {{ cancelingOrderId === order.orderId ? '取消中...' : '取消订单' }}
              </button>
            </div>
          </article>
        </div>
        <el-pagination
          v-if="page.total > 0"
          :current-page="page.current"
          :page-size="page.size"
          :total="page.total"
          layout="total, prev, pager, next, sizes"
          :page-sizes="[10, 20, 30]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <i-footer></i-footer>
    <fixed-right></fixed-right>
  </div>
</template>

<script>
import { getOrderList, verifyOrder as cancelOrderRequest } from '@/api/order'

const STATUS = {
  '-1': '退款中',
  '-2': '已退款',
  '-3': '退款中',
  0: '待付款',
  1: '待发货',
  2: '待收货',
  3: '待评价',
  4: '已完成',
  5: '待确认',
  6: '退款中',
  7: '已退款'
}

export default {
  name: 'IntegralOrders',
  data () {
    return {
      statusTabs: [
        { label: '全部订单', value: -1 },
        { label: '待确认', value: 5 },
        { label: '待发货', value: 1 },
        { label: '待收货', value: 2 },
        { label: '已完成', value: 4 },
        { label: '退款中', value: -2 },
        { label: '已退款', value: -3 }
      ],
      type: -1,
      orders: [],
      orderLoading: true,
      ordersRequestId: 0,
      cancelingOrderId: '',
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  mounted () {
    this.type = this.parseType(this.$route.query.type)
    this.fetchOrders()
  },
  methods: {
    parseType (type) {
      const parsed = Number(type)
      return this.statusTabs.some(item => item.value === parsed) ? parsed : -1
    },
    changeType (type) {
      this.type = type
      this.page.current = 1
      this.fetchOrders()
    },
    fetchOrders (adjustPage = false) {
      const requestId = ++this.ordersRequestId
      this.orderLoading = true
      return getOrderList({
        page: this.page.current,
        limit: this.page.size,
        orderType: 1,
        type: this.type
      }).then(res => {
        if (requestId !== this.ordersRequestId) return
        if (res.status !== 200 || !Array.isArray(res.data)) {
          throw new Error(res.msg || '积分订单加载失败，请重试')
        }
        this.orders = res.data
        this.page.total = Number(res.total || 0)
        if (adjustPage && this.orders.length === 0 && this.page.current > 1) {
          const lastPage = Math.max(1, Math.ceil(this.page.total / this.page.size))
          this.page.current = Math.min(this.page.current - 1, lastPage)
          return this.fetchOrders()
        }
      }).catch(error => {
        if (requestId !== this.ordersRequestId) return
        this.$message.warning((error && (error.msg || error.message)) || '积分订单加载失败，请重试')
      }).finally(() => {
        if (requestId === this.ordersRequestId) this.orderLoading = false
      })
    },
    canCancelOrder (order) {
      return Boolean(order.orderId) && Number(order._status && order._status._type) === 5 &&
        Number(order.paid) === 1 && Number(order.refundStatus) === 0
    },
    cancelOrder (order) {
      if (!this.canCancelOrder(order) || this.cancelingOrderId || this.orderLoading) return
      this.cancelingOrderId = order.orderId
      return this.$confirm('是否取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return cancelOrderRequest({ uni: order.orderId, text: '申请退款' })
      }).then(res => {
        if (!res || res.status !== 200) {
          throw new Error((res && res.msg) || '取消订单失败，请重试')
        }
        const currentOrder = this.orders.find(item => item.orderId === order.orderId)
        if (currentOrder) {
          currentOrder.refundStatus = 1
          currentOrder._status = { ...currentOrder._status, _type: '-1' }
        }
        console.info('积分订单取消申请已提交', { orderId: order.orderId })
        this.$message.success('取消申请已提交')
        return this.fetchOrders(true)
      }).catch(error => {
        if (error === 'cancel' || error === 'close') return
        console.warn('积分订单取消申请失败', { orderId: order.orderId })
        this.$message.warning((error && (error.msg || error.message)) || '取消订单失败，请重试')
      }).finally(() => {
        this.cancelingOrderId = ''
      })
    },
    handleSizeChange (size) {
      this.page.size = size
      this.page.current = 1
      this.fetchOrders()
    },
    handleCurrentChange (current) {
      this.page.current = current
      this.fetchOrders()
    },
    viewDetail (id) {
      this.$router.push({ path: '/integralOrderDetail', query: { orderId: id } })
    },
    totalNum (order) {
      return (order.cartInfo || []).reduce((total, item) => total + Number(item.cartNum || 0), 0)
    },
    totalPoints (order) {
      return (order.cartInfo || []).reduce((total, item) => {
        return total + this.itemPointPrice(item) * Number(item.cartNum || 0)
      }, 0)
    },
    getStatus (order) {
      const status = order && order._status ? order._status._type : null
      return STATUS[status] || '状态未知'
    },
    productImage (item) {
      const product = item.productInfo || {}
      const attrInfo = product.attrInfo || {}
      return attrInfo.image || product.image || require('../assets/noll.png')
    },
    productName (item) {
      const product = item.productInfo || {}
      return product.storeName || '--'
    },
    productSku (item) {
      const product = item.productInfo || {}
      const attrInfo = product.attrInfo || {}
      return attrInfo.skuName || product.storeInfo || '--'
    },
    isSeckillItem (item) {
      const product = item.productInfo || {}
      const attrInfo = product.attrInfo || {}
      return Number(item.seckillId) > 0
    },
    itemPointPrice (item) {
      const product = item.productInfo || {}
      const attrInfo = product.attrInfo || {}
      if (this.isSeckillItem(item)) {
        return Number(attrInfo.seckillIntegral)
      }
      return Number(attrInfo.integral || product.integral || item.payIntegral || 0)
    }
  }
}
</script>

<style scoped lang="less">
.integral-orders-title {
  padding-right: 20px;
}
.integral-orders {
  min-height: 300px;
}
.order-card {
  margin-bottom: 16px;
  border: 1px solid #eee;
  cursor: pointer;
}
.order-header,
.order-footer {
  display: flex;
  align-items: center;
  gap: 24px;
  min-height: 46px;
  padding: 0 16px;
  background: #f7f8f8;
  color: #777;
  font-size: 13px;
}
.order-header strong {
  margin-left: auto;
  color: #57aca7;
  font-weight: normal;
}
.order-time {
  padding: 16px;
  border-top: 1px solid #f1f1f1;
  color: #777;
  font-size: 13px;
}
.order-product {
  display: flex;
  align-items: center;
  min-height: 120px;
  padding: 16px;
  border-top: 1px solid #f1f1f1;
}
.order-product img {
  width: 72px;
  height: 72px;
  object-fit: contain;
}
.product-info {
  flex: 1;
  padding: 0 20px;
}
.product-info strong,
.product-info span {
  display: block;
}
.product-info strong {
  color: #333;
  font-weight: normal;
}
.product-info span {
  margin-top: 8px;
  color: #999;
  font-size: 12px;
}
.product-points {
  display: flex;
  width: 120px;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  color: #666;
  text-align: right;
}
.order-footer {
  justify-content: flex-end;
  border-top: 1px solid #f1f1f1;
}
.order-footer strong {
  color: #57aca7;
  font-size: 18px;
  font-weight: normal;
}
.cancel-order-button {
  min-width: 104px;
  min-height: 44px;
  margin: 8px 0;
  padding: 0 16px;
  border: 1px solid #57aca7;
  border-radius: 4px;
  background: #fff;
  color: #367d79;
  font-size: 14px;
  cursor: pointer;
}
.cancel-order-button:hover:not(:disabled) {
  background: #f1f8f7;
}
.cancel-order-button:focus-visible {
  outline: 2px solid #367d79;
  outline-offset: 2px;
}
.cancel-order-button:disabled {
  opacity: .6;
  cursor: not-allowed;
}
.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
